import Vue from 'vue';
import Router from 'vue-router';
//import LeituradeMapaVSL from '../components/LeituradeMapaVSL.vue';
//import KirvanoUpsellVideo from '../components/KirvanoUpsellVideo.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    /*{
      path: '/leitura',
      name: 'LeituradeMapaVSL',
      component: LeituradeMapaVSL,
      props: true
    },*/
    {
      path: '/enviodosdados',
      name: 'HelloWorld',
      component: () => import(/* webpackChunkName: "helloworld" */ '../components/HelloWorld.vue'),
      props: true
    },
    {
      path: '/pGwZSDj',
      name: 'PaginaPrincipal',
      component: () => import('@/components/PaginaPrincipal.vue'),
      props: true
    },
    {
      path: '/',
      name: 'KirvanoUpsellVideoCopy',
      component: () => import('@/components/KirvanoUpsellVideoCopy.vue'),
      props: false
    },
    {
      path: '/v1',
      name: 'KirvanoUpsellVideoCopyv1',
      component: () => import('@/components/KirvanoUpsellVideoCopyv1.vue'),
      props: false
    },
    {
      path: '/v2',
      name: 'KirvanoUpsellVideoCopyv2VSL',
      component: () => import('@/components/KirvanoUpsellVideoCopyv2VSL.vue'),
      props: false
    },
    {
      path: '/assinatura-poder',
      name: 'GerarAssinatura',
      component: () => import('@/components/GerarAssinatura.vue'),
      props: true
    },
    {
      path: '/g-ass',
      name: 'AssinaturaPoder',
      component: () => import('@/components/AssinaturaPoder.vue'),
      props: true
    },
    {
      path: '/obrigado-correio',
      name: 'ObrigadoCorreio',
      component: () => import('@/components/ObrigadoCorreio'),
      props: false
    },
    {
      path: '/brd',
      name: 'BRD',
      component: () => import('@/components/BRD.vue'),
      props: false
    },

],
});
